import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import "./StudentMobileLeftHeader.css";
import Swal from "sweetalert2";

export default function StudentMobileLeftside() {

const [menuOpen,setMenuOpen]=useState(false);
const [quizOpen,setQuizOpen]=useState(false);
const [subjectOpen, setSubjectOpen] = useState(false);
const [categoriesMenu, setCategoriesMenu] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState("");
const [performanceOpen,setPerformanceOpen]=useState(false);
const [isMobile,setIsMobile]=useState(window.innerWidth<768);

const [user,setUser]=useState(null);
const [isLoggedIn,setIsLoggedIn]=useState(false);

const location = useLocation();
const navigate = useNavigate();

/* ---------------- Normalize User ---------------- */

const normalizeUser = (u)=>{
if(!u) return null;

return{
id: u.id ?? u.userid ?? u.userId ?? null,
name: u.name ?? u.fullname ?? u.username ?? "User",
picture_url:
u.picture_url ??
(u.profile_pic
? String(u.profile_pic).startsWith("http")
? u.profile_pic
: `${API_BASE_URL}/${String(u.profile_pic).replace(/^\/+/, "")}`
: "")
};
};


const handleTestSelection = async (cat) => {
  const result = await Swal.fire({
    title: "Select Test Type",
    text: "Choose which type of mock test you’d like to start.",
    icon: "question",

    showCancelButton: true,
    showCloseButton: true,

    confirmButtonText: "Chapter-wise Test",
    cancelButtonText: "Master Test",

    confirmButtonColor: "#00a65a",
    cancelButtonColor: "#1c5592",

    reverseButtons: false,
    allowOutsideClick: false,
    allowEscapeKey: true,
  });

  if (result.isConfirmed) {
    navigate(`/mocktest/chapterwise/${cat.id}`);
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    navigate(`/mocktest/masterquiz/${cat.id}`);
  }
};
  const user2 = JSON.parse(sessionStorage.getItem("user"));
  const userId = user2?.id;
  /* ---------------------------------------------------
   FETCH SUBJECT CATEGORIES (ONLY WHEN LOGGED IN)
--------------------------------------------------- */
  useEffect(() => {
    if (!userId) return;

    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/active_book_categories.php?user_id=${userId}`
        );

        if (!res.ok) throw new Error("API failed");

        const data = await res.json();

        if (data?.success && Array.isArray(data.categories)) {
          const formatted = data.categories.map((cat) => ({
            id: cat.category_id,
            title: cat.category_name || "Untitled Subject",
            image:
              cat.picture_url && cat.picture_url.trim() !== ""
                ? cat.picture_url
                : `${process.env.PUBLIC_URL}/assets/img/subject-placeholder.jpg`,
            isActive: Boolean(cat.isActive),
            daysLeft: Number(cat.daysLeft ?? 0),
          }));

          setCategoriesMenu(formatted);
        } else {
          setCategoriesMenu([]);
          setError("No subjects found");
        }
      } catch (err) {
        console.error("Subject fetch error:", err);
        setError("Failed to load subjects");
        setCategoriesMenu([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [userId]);
/* ---------------- Load User ---------------- */

useEffect(()=>{

try{
const raw=sessionStorage.getItem("user");

if(raw){
const parsed=JSON.parse(raw);
setUser(normalizeUser(parsed));
setIsLoggedIn(true);
}

}catch{
setUser(null);
setIsLoggedIn(false);
}

const onUserUpdated=(e)=>{
if(e?.detail){
sessionStorage.setItem("user",JSON.stringify(e.detail));
setUser(normalizeUser(e.detail));
setIsLoggedIn(true);
}
};

window.addEventListener("userUpdated",onUserUpdated);

return()=>{
window.removeEventListener("userUpdated",onUserUpdated);
};

},[]);


/* ---------------- Mobile Resize ---------------- */

useEffect(()=>{

const resize=()=>setIsMobile(window.innerWidth<991);

window.addEventListener("resize",resize);

return()=>window.removeEventListener("resize",resize);

},[]);


/* ---------------- Logout ---------------- */

const handleLogout=()=>{
sessionStorage.removeItem("user");
setUser(null);
setIsLoggedIn(false);
navigate("/login");
};


/* ---------------- Profile Image ---------------- */

const profileImage =
user?.picture_url?.trim()
? user.picture_url
: `${process.env.PUBLIC_URL}/assets/img/profile.png`;


/* ---------------- Close Menu ---------------- */

const closeMenu=()=>{
setMenuOpen(false);
};


return(

<>


{/* MOBILE HEADER */}

{isMobile && (

<div className="mobile-header">

<img
className="logo"
alt="Pilot Guide"
src="/assets/img/the-pilot-guide-logo.png"
/>

<div
className="menu-icon"
onClick={()=>setMenuOpen(true)}
>
<i className="bi bi-list"></i>
</div>

</div>

)}


{/* OVERLAY */}

{menuOpen && (

<div
className="overlay"
onClick={()=>setMenuOpen(false)}
></div>

)}


{/* SIDEBAR */}

<div className={`sidebar ${menuOpen ? "open":""}`}>

<div
className="sidebar-close"
onClick={()=>setMenuOpen(false)}
>
<i className="bi bi-x-lg"></i>
</div>


{/* PROFILE */}

<div className="profile-box">

<img src={profileImage} alt="profile"/>

<h4>{user?.name}</h4>

</div>

<ul>

<li>
<Link to="/studentdashboard"
className={location.pathname==="/studentdashboard"?"active":""}
onClick={closeMenu}>
Dashboard
</Link>
</li>


<li>
<Link to="/announcement"
className={location.pathname==="/announcement"?"active":""}
onClick={closeMenu}>
Announcement
</Link>
</li>

<li>
<Link to="/subscription"
className={location.pathname==="/subscription"?"active":""}
onClick={closeMenu}>
Subscriptions
</Link>
</li>

<li>

<button
onClick={()=>setQuizOpen(!quizOpen)}
className={quizOpen?"active":""}>

View Past Result

<i className={`bi bi-chevron-down arrow ${quizOpen?"rotate":""}`}></i>

</button>

{quizOpen &&(

<ul>

<li>
<Link to="/masterquizlist" onClick={closeMenu}>
Master Quiz List
</Link>
</li>

<li>
<Link to="/chapterwisequizlist" onClick={closeMenu}>
Chapterwise Quiz List
</Link>
</li>

</ul>

)}

</li>

 {/* subject */}
             <li>
  <button
    className={`d-flex align-items-center w-100 bg-transparent border-0 text-start py-2 ${subjectOpen ? "active" : ""}`}
    onClick={() => setSubjectOpen(!subjectOpen)}
  >
    Subject
    <i className={`bi bi-chevron-down arrow ${subjectOpen ? "rotate":""}`}></i>
   
  </button>

  {subjectOpen && (
    <ul>
      {categoriesMenu.map((cat) => {
        const isActive = cat.isActive && cat.daysLeft > 0;

        const path = isActive
          ? `/start-test/${cat.id}`
          : `/subscription`;

        return (
          <li
  key={cat.id}
  className={location.pathname === path ? "active" : ""}
>
  <Link
    to={isActive ? "#" : `/subscription`}
    onClick={(e) => {
      if (isActive) {
        e.preventDefault(); // stop default navigation
        handleTestSelection(cat); // open modal
      }
    }}
  >
    {/* Title */}
    <span>{cat.title}</span>

    {/* Lock Icon */}
    {!isActive && (
      <i className="fa-solid fa-lock ms-auto text-danger"></i>
    )}
  </Link>
</li>
        );
      })}
    </ul>
  )}
</li>
<li>

<button
onClick={()=>setPerformanceOpen(!performanceOpen)}
className={performanceOpen?"active":""}>

Performance & Results

<i className={`bi bi-chevron-down arrow ${performanceOpen?"rotate":""}`}></i>

</button>

{performanceOpen &&(

<ul>

<li>
<Link to="/analysis" onClick={closeMenu}>
Overall Performance
</Link>
</li>

</ul>

)}

</li>

<li>
<Link to="/subscriptionlist"
className={location.pathname==="/subscriptionlist"?"active":""}
onClick={closeMenu}>
Transaction
</Link>
</li>

<li>
<Link to="/profile"
className={location.pathname==="/profile"?"active":""}
onClick={closeMenu}>
User Profile
</Link>
</li>

<li>
<Link to="/profile/password-change"
className={location.pathname==="/profile/password-change"?"active":""}
onClick={closeMenu}>
Change Password
</Link>
</li>

</ul>


<button className="logout-btn" onClick={handleLogout}>
Log Out
</button>

</div>

</>

);

}